import React from "react";

const GameStatus = ({ score, continueGame, quitGame }) => {
  return (
    <div style={{ display: "flex", marginLeft: "5%", flexDirection: "column" }}>
      <h3>Score: {score}</h3>
      <div style={{ display: "flex", flexDirection: "row", width: "20%" }}>
        <button
          onClick={continueGame}
          style={{ marginBottom: "10px", height: "38px", borderRadius: "4px" }} // Gap between buttons and increased height
        >
          Continue
        </button>
        <button
          onClick={quitGame}
          style={{ height: "38px", borderRadius: "4px", marginLeft: "12px" }} // Increased height
        >
          New Game
        </button>
      </div>{" "}
    </div>
  );
};

export default GameStatus;
